var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { class: { "content-type--items-is-dragging": _setup.isDragging } },
      [
        _setup.items.length
          ? _c(
              _setup.draggable,
              _vm._b(
                {
                  attrs: {
                    direction: "vertical",
                    draggable: "[data-draggable-item]",
                  },
                  on: {
                    end: _setup.onDragEnd,
                    start: function ($event) {
                      _setup.isDragging = true
                    },
                  },
                  model: {
                    value: _setup.items,
                    callback: function ($$v) {
                      _setup.items = $$v
                    },
                    expression: "items",
                  },
                },
                "draggable",
                _setup.dragOptions,
                false
              ),
              [
                _c(
                  "transition-group",
                  {
                    staticClass: "list-group overflow-hidden",
                    attrs: { type: "transition" },
                  },
                  _vm._l(_setup.items, function (item) {
                    return _c(
                      "a",
                      {
                        key: item.id,
                        ref: "contentTypeItem",
                        refInFor: true,
                        staticClass:
                          "list-group-item ps-1 d-flex align-items-center",
                        class: {
                          active: item.id === _setup.selectedId,
                          disabled: _setup.ajaxInProgress,
                        },
                        attrs: {
                          "data-draggable-item": "",
                          draggable: "true",
                          href: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _setup.editItem(item.id)
                          },
                        },
                      },
                      [
                        _c(_setup.DragHandle, {
                          staticClass: "content-type--item-drag-handle",
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "flex-fill" }, [
                          _vm._v(_vm._s(item.legend)),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "bi-pencil-square",
                          attrs: {
                            "data-bs-toggle": "offcanvas",
                            "data-bs-target": "#contentTypeFieldsetOffcanvas",
                            role: "button",
                            "aria-controls": "contentTypeFieldsetOffcanvas",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _setup.setFormData(item)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }